import { RouteConfig } from 'vue-router';

import Configuration from '@/views/configuration/Configuration.vue';

export const configurationRoute: RouteConfig = {
  path: '',
  name: 'configuration',
  component: Configuration,
  meta: {
    authorized: true
  }
};
